import React from "react";
import { ShieldAlert } from "lucide-react";
import { useL } from "@/context/I18nContext";

export default function SecretWarning({ className = "" }) {
  const L = useL();
  return (
    <div
      data-testid="secret-warning"
      className={`flex items-start gap-3 rounded-lg border border-gold/30 bg-gold/10 p-3 text-sm text-gold ${className}`}
    >
      <ShieldAlert className="h-5 w-5 shrink-0 mt-0.5" />
      <p>
        {L(
          "Non inserire seed phrase complete, chiavi private, PIN o password complete.",
          "Do not enter full seed phrases, private keys, PINs or complete passwords.",
          "Geben Sie keine vollständigen Seed-Phrasen, privaten Schlüssel, PINs oder vollständigen Passwörter ein."
        )}
      </p>
    </div>
  );
}
